import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Detail from '../views/Detail.vue';
import Payment from '../views/Payment.vue';
import TgPayment from '../views/TgPayment.vue';
import WalletPay from '../views/WalletPay.vue';
import WalletLink from '../views/WalletLink.vue';
import Woker from '../woker/Woker.vue';
import Login from '../admin/Login.vue';
import Index from '../admin/Index.vue';
import Trxtk from '../views/Trxtk.vue';
import Menber from '../views/Tgmenber.vue';
import TrxExchange from '../views/TrxExchange.vue';
import EnergyUse from '../views/EnergyUse.vue';
import TudouDb from '../views/TuDoudb.vue';
import PhoneCode from '../views/PhoneCode.vue';
import ExpressDelivery from '../views/ExpressDelivery.vue';
import ExpressPayment from '../views/ExpressPayment.vue';
import MiningEarnings from '../views/MiningEarnings.vue';
import MiningPayment from '../views/MiningPayment.vue';
import sgkPage from '../woker/HomePage.vue';
import wokerDetail1 from '../woker/detail/wokerDetail1.vue';
import wokerDetail2 from '../woker/detail/wokerDetail2.vue';
import wokerDetail3 from '../woker/detail/wokerDetail3.vue';
import wokerDetail4 from '../woker/detail/wokerDetail4.vue';
import wokerDetail5 from '../woker/detail/wokerDetail5.vue';
import wokerDetail6 from '../woker/detail/wokerDetail6.vue';
import wokerDetail7 from '../woker/detail/wokerDetail7.vue';
import wokerDetail8 from '../woker/detail/wokerDetail8.vue';
import wokerDetail9 from '../woker/detail/wokerDetail9.vue';
import wokerDetail10 from '../woker/detail/wokerDetail10.vue';
import wokerDetail11 from '../woker/detail/wokerDetail11.vue';
import wokerDetail12 from '../woker/detail/wokerDetail12.vue';
import wokerDetail13 from '../woker/detail/wokerDetail13.vue';
import wokerDetail14 from '../woker/detail/wokerDetail14.vue';
import wokerDetail15 from '../woker/detail/wokerDetail15.vue';
import wokerDetail16 from '../woker/detail/wokerDetail16.vue';
import wokerDetail17 from '../woker/detail/wokerDetail17.vue';
import wokerDetail18 from '../woker/detail/wokerDetail18.vue';
import wokerDetail19 from '../woker/detail/wokerDetail19.vue';
import wokerDetail20 from '../woker/detail/wokerDetail20.vue';


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/woker',
    name: 'woker',
    component: Woker,
  },
  {
    path: '/detail/:data',
    name: 'Detail',
    component: Detail,
  },
  {
    path: '/productDetail/:data',
    name: 'ProductDetail',
    component: Detail,
  },
  {
    path: '/trxtk',
    name: 'Trxtk',
    component: Trxtk,
  },
  {
    path: '/sgkPage',
    name: 'SgkPage',
    component: sgkPage,
  },
  {
    path: '/tudouDb',
    name: 'TudouDb',
    component: TudouDb,
  },
  {
    path: '/expressDelivery',
    name: 'ExpressDelivery',
    component: ExpressDelivery,
  },
  {
    path: '/expressDelivery/:data',
    name: 'ExpressDeliveryDetail',
    component: ExpressDelivery,
  },
  {
    path: '/expressPayment/:data',
    name: 'ExpressPayment',
    component: ExpressPayment,
  },
  {
    path: '/wakuang',
    name: 'MiningEarnings',
    component: MiningEarnings,
  },
  {
    path: '/miningPayment/:data',
    name: 'MiningPayment',
    component: MiningPayment,
  },
  
  {
    path: '/wokerDetail1',
    name: 'WokerDetail1',
    component: wokerDetail1,
  },
  {
    path: '/wokerDetail2',
    name: 'WokerDetail2',
    component: wokerDetail2,
  },
  {
    path: '/wokerDetail2',
    name: 'WokerDetail2',
    component: wokerDetail2,
  },
  {
    path: '/wokerDetail3',
    name: 'WokerDetail3',
    component: wokerDetail3,
  },
  {
    path: '/wokerDetail4',
    name: 'WokerDetail4',
    component: wokerDetail4,
  },
  {
    path: '/wokerDetail5',
    name: 'WokerDetail5',
    component: wokerDetail5,
  },
  {
    path: '/wokerDetail6',
    name: 'WokerDetail6',
    component: wokerDetail6,
  },
  {
    path: '/wokerDetail7',
    name: 'WokerDetail7',
    component: wokerDetail7,
  },
  {
    path: '/wokerDetail8',
    name: 'WokerDetail8',
    component: wokerDetail8,
  },
  {
    path: '/wokerDetail9',
    name: 'WokerDetail9',
    component: wokerDetail9,
  },
  {
    path: '/wokerDetail10',
    name: 'WokerDetail10',
    component: wokerDetail10,
  },
  {
    path: '/wokerDetail11',
    name: 'WokerDetail11',
    component: wokerDetail11,
  },
  {
    path: '/wokerDetail12',
    name: 'WokerDetail12',
    component: wokerDetail12,
  },
  {
    path: '/wokerDetail13',
    name: 'WokerDetail13',
    component: wokerDetail13,
  },
  {
    path: '/wokerDetail14',
    name: 'WokerDetail14',
    component: wokerDetail14,
  },
  {
    path: '/wokerDetail15',
    name: 'WokerDetail15',
    component: wokerDetail15,
  },
  {
    path: '/wokerDetail16',
    name: 'WokerDetail16',
    component: wokerDetail16,
  },
  {
    path: '/wokerDetail17',
    name: 'WokerDetail17',
    component: wokerDetail17,
  },
  {
    path: '/wokerDetail18',
    name: 'WokerDetail18',
    component: wokerDetail18,
  },
  {
    path: '/wokerDetail19',
    name: 'WokerDetail19',
    component: wokerDetail19,
  },
  {
    path: '/wokerDetail20',
    name: 'WokerDetail20',
    component: wokerDetail20,
  },
  {
    path: '/energyUsePage',
    name: 'EnergyUse',
    component: EnergyUse,
  },
  {
    path: '/phoneCodePage',
    name: 'PhoneCode',
    component: PhoneCode,
  },
  {
    path: '/tgmenberPage',
    name: 'TgMenber',
    component: Menber,
  },
  {
    path: '/TrxExchangePage',
    name: 'TrxExchange',
    component: TrxExchange,
  },

  {
    path: '/payment/:data',
    name: 'Payment',
    component: Payment,
  },

  {
    path: '/tgPayment',
    name: 'TgPayment',
    component: TgPayment,
  },
  
  {
    path: '/walletLink/referralCode/:referralCode',
    name: 'WalletLink',
    component: WalletLink,
  },

  {
    path: '/walletPay/tgNo/:tgNo/referralCode/:referralCode',
    name: 'WalletPay',
    component: WalletPay,
  },

  {
    path: '/Login',
    name: 'Login',
    component: Login,
  },

  {
    path: '/Index',
    name: 'Index',
    component: Index,
    meta: { requiresAdmin: true },  // 👈 需要 admin 权限
  },
];
 
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

function getCurrentUserRole() {
  return localStorage.getItem('role') || 'guest'; // 默认值 guest
}

router.beforeEach((to, from, next) => {
  const role = getCurrentUserRole(); // 例如从 localStorage 或 Pinia/Vuex 获取角色

  if (to.meta.requiresAdmin) {
    if (role === 'admin') {
      next(); // ✅ 允许访问
    } else {
      alert("⛔ 权限不足，仅限管理员访问！");
      next(false); // ❌ 阻止跳转
    }
  } else {
    next(); // 不需要权限的正常访问
  }
});
 
export default router;
